var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFixedCost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 16c0-2.543-1.603-4.81-4-5.657V8c0-1.105-.895-2-2-2H8c-1.105 0-2 .895-2 2v2.343C3.602 11.19 1.999 13.457 1.999 16S3.602 20.81 6 21.657V24c0 .53.21 1.04.586 1.414C6.96 25.79 7.47 26 8 26h16c1.105 0 2-.895 2-2v-2.343c2.397-.847 4-3.114 4-5.657z",
    transform: "translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20c-2.21 0-4-1.79-4-4s1.79-4 4-4M12 16L18 16",
    transform: "translate(8 8)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedCost);
export default __webpack_public_path__ + "static/media/fixed-cost.d5b3a89296ef193566f2078042515014.svg";
export { ForwardRef as ReactComponent };